import config from "../config";

import { fetchWithRetry } from ".";
import { auth } from "../firebase/firebase";

export async function listPats() {
  const token = auth.currentUser?.accessToken;
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/pats`;
  const response = await fetchWithRetry(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

export async function createPat(patData) {
  const token = auth.currentUser?.accessToken;
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/pats`;
  const response = await fetchWithRetry(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(patData),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

export async function deletePat(patId) {
  const token = auth.currentUser?.accessToken;
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/pats/${patId}`;
  const response = await fetchWithRetry(url, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}
